import React, { useEffect } from 'react';
import { invoiceTemplatesJs } from './invoiceTemplatesJs.jsx';

const TemplateSelectorBootstrap = ({
  selectedTemplate,
  onSelectTemplate,
  availableTemplates,
}) => {
  // Ensure a template is selected on mount
  useEffect(() => {
    // Select default template from settings if available, otherwise fall back to 'classic'
    const defaultTemplate = availableTemplates?.defaultTemplate || 'classic';

    // Only select if the template is enabled
    if (availableTemplates && availableTemplates[defaultTemplate] && selectedTemplate !== defaultTemplate) {
      onSelectTemplate(defaultTemplate);
    } else if (!selectedTemplate) {
      onSelectTemplate('classic');
    }
  }, [selectedTemplate, onSelectTemplate, availableTemplates]);

  return (
    <div className="w-100 mt-1">
      <div className="section-header mb-1">
        <h5 className="mb-0">Offertmall</h5>
        <p className="text-muted small mb-0">Välj utseende för offert. Olika mallar kan vara lämpliga för olika branscher eller kundtyper.</p>
      </div>
      <div className="row row-cols-1 row-cols-md-3 g-4 mt-2">
        {invoiceTemplatesJs.map((template) => (
          <div key={template.id} className="col">
            <div
              className={`card h-100 template-card ${selectedTemplate === template.id ? 'active' : ''}`}
              onClick={() => onSelectTemplate(template.id)}
              style={{ cursor: 'pointer' }}
            >
              <div className="position-relative template-preview">
                <img
                  src={template.thumbnail}
                  alt={`${template.name} preview`}
                  className="w-100 h-100 object-fit-contain rounded border border-gray-200 bg-white"
                  draggable={false}
                  style={{
                    pointerEvents: 'none',
                    maxWidth: '100%',
                    maxHeight: '100%',
                  }}
                />
                {selectedTemplate === template.id && (
                  <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(var(--bs-primary-rgb), 0.1)' }}>
                    <div className="bg-primary text-white rounded-circle shadow d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  </div>
                )}

              </div>
              <div className="card-body template-card-info">
                <h5 className="card-title">{template.name}</h5>
                <p className="card-text small text-muted">{template.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelectorBootstrap;





// import React, { useEffect } from 'react';
// import { invoiceTemplatesJs } from './invoiceTemplatesJs.jsx';

// const TemplateSelectorBootstrap = ({
//   selectedTemplate,
//   onSelectTemplate,
//   availableTemplates,
// }) => {
//   // Ensure classic template is selected on mount or when availableTemplates changes
//   useEffect(() => {
//     // Only run this initialization if selectedTemplate is null or undefined
//     if (!selectedTemplate) {
//       // Select default template from settings if available, otherwise fall back to 'classic'
//       const defaultTemplate = availableTemplates?.defaultTemplate || 'classic';

//       // Only select if the template is enabled
//       if (availableTemplates && availableTemplates[defaultTemplate]) {
//         onSelectTemplate(defaultTemplate);
//       } else {
//         onSelectTemplate('classic');
//       }
//     }
//   }, [availableTemplates, onSelectTemplate]); // Removed selectedTemplate from dependencies

//   return (
//     <div className="w-100 mt-1">
//       <div className="section-header mb-1">
//         <h5 className="mb-0">Offertmall</h5>
//         <p className="text-muted small mb-0">Välj utseende för offerten. Olika mallar kan vara lämpliga för olika branscher eller kundtyper.</p>
//       </div>
//       <div className="row row-cols-1 row-cols-md-3 g-4 mt-2">
//         {invoiceTemplatesJs.map((template) => (
//           <div key={template.id} className="col">
//             <div
//               className={`card h-100 template-card ${selectedTemplate === template.id ? 'active' : ''} 
//                 ${template.id !== 'classic' ? 'disabled-template' : ''}`}
//               onClick={() => template.id === 'classic' && onSelectTemplate(template.id)}
//               style={template.id !== 'classic' ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
//             >
//               <div className="position-relative template-preview">
//                 <img
//                   src={template.thumbnail}
//                   alt={`${template.name} preview`}
//                   className="w-100 h-100 object-fit-contain rounded border border-gray-200 bg-white"
//                   draggable={false}
//                   style={{
//                     pointerEvents: 'none',
//                     maxWidth: '100%',
//                     maxHeight: '100%',
//                   }}
//                 />
//                 {selectedTemplate === template.id && (
//                   <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(var(--bs-primary-rgb), 0.1)' }}>
//                     <div className="bg-primary text-white rounded-circle shadow d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
//                       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <polyline points="20 6 9 17 4 12"></polyline>
//                       </svg>
//                     </div>
//                   </div>
//                 )}

//                 {/* Add "Coming Soon" badge for non-classic templates */}
//                 {template.id !== 'classic' && (
//                   <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}>
//                     <div className="bg-secondary text-white px-3 py-2 rounded-pill shadow">
//                       Kommer snart
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className="card-body template-card-info">
//                 <h5 className="card-title">{template.name}</h5>
//                 <p className="card-text small text-muted">{template.description}</p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default TemplateSelectorBootstrap;